import React from "react";

export const Field = ({ label, children, full }) => (
  <div className={full ? "md:col-span-2" : ""}>
    <label className="block text-xs uppercase tracking-[0.2em] text-[#4A5568] mb-2 font-semibold">
      {label}
    </label>
    {children}
  </div>
);
